import React from 'react';
import { InlineConfirm } from '../Confirm';
import './style.scss';

export function List(props) {
  return <div className={`item-list ${props.className || ''}`}>{props.children}</div>;
}

export function Row(props) {
  let actions = [];

  if (props.onDelete) {
    actions.push(<InlineConfirm key={1} onConfirm={props.onDelete} />);
  }

  let actions_html = actions.length ? <div className="actions cell"> {actions.map(a => a)}</div> : '';

  return (
    <div
      onClick={props.onClick}
      className={`rowContainer ${props.className || ''} ${props.isHeader ? 'header' : ''} ${props.sum ? 'sum' : ''} ${
        props.clickable ? 'pointer' : ''
      }`}
    >
      {props.children}
      {actions_html}
    </div>
  );
}
export function Cell(props) {
  let classNames = (props.className || '').split(' ').concat(['cell']);
  if (props.right) classNames.push('right');
  return (
    <div onClick={props.onClick} className={classNames.join(' ')}>
      {props.children}
    </div>
  );
}
